export default "__VITE_ASSET__CttSHWVm__"